import { getEnv } from './env';

// AS OAuth params captured from the LoginPage URL and forwarded to /auth/google/start.
// The backend validates client_id/redirect_uri, generates a CSRF handle, and
// issues the 302 to Cognito — the client never constructs the Cognito URL directly.
export interface OAuthParams {
  client_id: string;
  redirect_uri: string;
  state: string;
  code_challenge: string;
  code_challenge_method: string;
  nonce: string;
  scope: string;
}

// Navigate to /auth/google/start with the AS OAuth params. The backend owns
// the CSRF nonce (HttpOnly __Host-g_state cookie) and the Cognito redirect —
// the client no longer writes document.cookie or constructs the Cognito URL.
export function startGoogleLogin(params: OAuthParams): void {
  const { authBaseUrl } = getEnv();

  const qs = new URLSearchParams({
    client_id: params.client_id,
    redirect_uri: params.redirect_uri,
    state: params.state,
    code_challenge: params.code_challenge,
    code_challenge_method: params.code_challenge_method,
    nonce: params.nonce,
    scope: params.scope,
  });

  window.location.assign(`${authBaseUrl}/auth/google/start?${qs.toString()}`);
}
